import {API_URL, apiGet} from '../api'
import {ApiRes} from '../../types/api'

interface ICreatedBy {
    id: string
    name: string
    thumbnail: string
}

export interface IAdvertisement {
    created_at: number
    created_by: ICreatedBy
    description?: string
    id: string
    image?: string
    is_active?: boolean
    language?: string
    mobile_url?: string
    pc_url?: string
    pk?: number
    thumbnail?: string
    title?: string
}

export const getAdvertisement = async (
    size: number = 100,
    current_page: number = 1,
): Promise<ApiRes<IAdvertisement[]>> => {
    return await apiGet(API_URL, `admin/advertisement?page_size=${size}&current_page=${current_page}`)
}
